var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconMapPin(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M10 2.75c-2.912 0-5.25 2.316-5.25 5.145 0 2.26 1.36 4.615 2.838 6.482A24.354 24.354 0 0010 16.99a24.369 24.369 0 002.412-2.615c1.477-1.866 2.838-4.22 2.838-6.481 0-2.83-2.338-5.145-5.25-5.145zM10 18l-.483.573-.007-.005-.015-.013a8.484 8.484 0 01-.255-.225 25.85 25.85 0 01-2.828-3.022C4.889 13.384 3.25 10.687 3.25 7.895 3.25 4.212 6.285 1.25 10 1.25s6.75 2.962 6.75 6.645c0 2.792-1.64 5.49-3.162 7.413a25.835 25.835 0 01-2.828 3.022 14.128 14.128 0 01-.255.225l-.015.013-.006.005L10 18zm0 0l.483.574a.75.75 0 01-.966 0L10 18zm0-11.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM7.25 8a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0z", clipRule: "evenodd" })));
}
export default IconMapPin;
